function indexHeroInit() {
	$(".hero-slider").slick({
		arrows: false,
		infinite: true,
		fade: true,
		speed: 1000,
	});

	$("[data-hero-slide='next']").on("click", function() {
		$(".hero-slider").slick("slickNext");
	});
	$("[data-hero-slide='prev']").on("click", function() {
		$(".hero-slider").slick("slickPrev");
	});

	$(".hero-slider").on("beforeChange", function(
		slick,
		currentSlide,
		nextSlide,
		targetSlide
	) {
		$(".js-overlay").removeClass("js-overlay-active");
	});

	$(".hero-slider").on("afterChange", function(
		slick,
		currentSlide,
		nextSlide,
		targetSlide
	) {
		$(".slick-current .js-overlay").addClass("js-overlay-active");
	});
}
